import * as React from "react";
import type { SVGProps } from "react";
const SvgForsidenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 62" {...props}>
    <path
      d="M1759.3 1071.39a6.26 6.26 0 0 1-4.61 1.6l-2.69-.04V1098a4 4 0 0 1-4 4h-12v-13a2.006 2.006 0 0 0-2-2h-11a2.006 2.006 0 0 0-2 2v13h-12a4 4 0 0 1-4-4v-25.82l-2.79-.05a6.3 6.3 0 0 1-4.57-1.75 2.24 2.24 0 0 1 .19-3.3l26.64-25.62a7.26 7.26 0 0 1 8.9.15l25.85 26.48a2.42 2.42 0 0 1 .77 1.73 2.35 2.35 0 0 1-.69 1.57"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-1697 -1040)"
    />
  </svg>
);
export default SvgForsidenIcon;
